import { createMessagingController } from './masonry-engine-messaging-controller';
import { createStateControllerStore } from './masonry-engine-state-controller';
import { InstanceResources } from './types/masonry-engine-config.types';

export const createInstanceResources = (): InstanceResources => {
  const stateControllerStore = createStateControllerStore();
  return {
    stateControllerStore,
    messagingController: createMessagingController(stateControllerStore),
  };
};
